var map = {
	"./Cantact_KCC_Team.png": "./src/assets/img/Cantact_KCC_Team.png",
	"./ITA-question.png": "./src/assets/img/ITA-question.png",
	"./Icon-OAK.png": "./src/assets/img/Icon-OAK.png",
	"./Important.png": "./src/assets/img/Important.png",
	"./Insights-icon – 1.png": "./src/assets/img/Insights-icon – 1.png",
	"./Insights-icon – 2.png": "./src/assets/img/Insights-icon – 2.png",
	"./Insights-icon – 3.png": "./src/assets/img/Insights-icon – 3.png",
	"./Insights-icon – 4.png": "./src/assets/img/Insights-icon – 4.png",
	"./Insights-icon – 5.png": "./src/assets/img/Insights-icon – 5.png",
	"./KPblue_KCC-05.png": "./src/assets/img/KPblue_KCC-05.png",
	"./Note.png": "./src/assets/img/Note.png",
	"./Rules.png": "./src/assets/img/Rules.png",
	"./Site Administrator.png": "./src/assets/img/Site Administrator.png",
	"./SiteAdministrator.png": "./src/assets/img/SiteAdministrator.png",
	"./authorise-bg.png": "./src/assets/img/authorise-bg.png",
	"./avatar_bg.png": "./src/assets/img/avatar_bg.png",
	"./bg-Client-01.png": "./src/assets/img/bg-Client-01.png",
	"./bg-Client-02.png": "./src/assets/img/bg-Client-02.png",
	"./bg-Client-03.png": "./src/assets/img/bg-Client-03.png",
	"./bg-Client-04.png": "./src/assets/img/bg-Client-04.png",
	"./bg-Client-05.png": "./src/assets/img/bg-Client-05.png",
	"./bg-Client-06.png": "./src/assets/img/bg-Client-06.png",
	"./bg-ClientHover-01.png": "./src/assets/img/bg-ClientHover-01.png",
	"./bg-ClientHover-02.png": "./src/assets/img/bg-ClientHover-02.png",
	"./bg-ClientHover-03.png": "./src/assets/img/bg-ClientHover-03.png",
	"./bg-ClientHover-04.png": "./src/assets/img/bg-ClientHover-04.png",
	"./bg-ClientHover-05.png": "./src/assets/img/bg-ClientHover-05.png",
	"./bg-ClientHover-06.png": "./src/assets/img/bg-ClientHover-06.png",
	"./bg-ClientHover-07.png": "./src/assets/img/bg-ClientHover-07.png",
	"./bg-Introduction.png": "./src/assets/img/bg-Introduction.png",
	"./bg-Overview.png": "./src/assets/img/bg-Overview.png",
	"./bg-contact.png": "./src/assets/img/bg-contact.png",
	"./bg_Overview.png": "./src/assets/img/bg_Overview.png",
	"./bg_home.png": "./src/assets/img/bg_home.png",
	"./bg_site-hover.png": "./src/assets/img/bg_site-hover.png",
	"./clara.png": "./src/assets/img/clara.png",
	"./client-icon01.png": "./src/assets/img/client-icon01.png",
	"./client-icon02.png": "./src/assets/img/client-icon02.png",
	"./client-icon03.png": "./src/assets/img/client-icon03.png",
	"./client-icon04.png": "./src/assets/img/client-icon04.png",
	"./client-icon05.png": "./src/assets/img/client-icon05.png",
	"./client-icon06.png": "./src/assets/img/client-icon06.png",
	"./client-icon07.png": "./src/assets/img/client-icon07.png",
	"./client-icon08.png": "./src/assets/img/client-icon08.png",
	"./clientUser/CN/Tech_01.png": "./src/assets/img/clientUser/CN/Tech_01.png",
	"./clientUser/CN/Tech_02.png": "./src/assets/img/clientUser/CN/Tech_02.png",
	"./clientUser/CN/Tech_03.png": "./src/assets/img/clientUser/CN/Tech_03.png",
	"./clientUser/CN/Tech_04.png": "./src/assets/img/clientUser/CN/Tech_04.png",
	"./clientUser/CN/Tech_05.png": "./src/assets/img/clientUser/CN/Tech_05.png",
	"./clientUser/CN/Tech_06.png": "./src/assets/img/clientUser/CN/Tech_06.png",
	"./clientUser/CN/banner01.png": "./src/assets/img/clientUser/CN/banner01.png",
	"./clientUser/CN/banner02.png": "./src/assets/img/clientUser/CN/banner02.png",
	"./clientUser/CN/banner03.png": "./src/assets/img/clientUser/CN/banner03.png",
	"./clientUser/CN/banner04.png": "./src/assets/img/clientUser/CN/banner04.png",
	"./clientUser/CN/banner05.png": "./src/assets/img/clientUser/CN/banner05.png",
	"./clientUser/CN/banner06.png": "./src/assets/img/clientUser/CN/banner06.png",
	"./clientUser/CN/banner07.png": "./src/assets/img/clientUser/CN/banner07.png",
	"./clientUser/CN/banner08.png": "./src/assets/img/clientUser/CN/banner08.png",
	"./clientUser/CN/banner09.png": "./src/assets/img/clientUser/CN/banner09.png",
	"./clientUser/CN/banner10.png": "./src/assets/img/clientUser/CN/banner10.png",
	"./clientUser/CN/banner11.png": "./src/assets/img/clientUser/CN/banner11.png",
	"./clientUser/CN/banner12.png": "./src/assets/img/clientUser/CN/banner12.png",
	"./clientUser/CN/banner13.png": "./src/assets/img/clientUser/CN/banner13.png",
	"./clientUser/CN/banner14.png": "./src/assets/img/clientUser/CN/banner14.png",
	"./clientUser/CN/banner15.png": "./src/assets/img/clientUser/CN/banner15.png",
	"./clientUser/CN/banner16.png": "./src/assets/img/clientUser/CN/banner16.png",
	"./clientUser/CN/banner17.png": "./src/assets/img/clientUser/CN/banner17.png",
	"./clientUser/CN/banner18.png": "./src/assets/img/clientUser/CN/banner18.png",
	"./clientUser/CN/banner19.png": "./src/assets/img/clientUser/CN/banner19.png",
	"./clientUser/CN/banner20.png": "./src/assets/img/clientUser/CN/banner20.png",
	"./clientUser/CN/banner21.png": "./src/assets/img/clientUser/CN/banner21.png",
	"./clientUser/EN/Tech_01.png": "./src/assets/img/clientUser/EN/Tech_01.png",
	"./clientUser/EN/Tech_02.png": "./src/assets/img/clientUser/EN/Tech_02.png",
	"./clientUser/EN/Tech_03.png": "./src/assets/img/clientUser/EN/Tech_03.png",
	"./clientUser/EN/Tech_04.png": "./src/assets/img/clientUser/EN/Tech_04.png",
	"./clientUser/EN/Tech_05.png": "./src/assets/img/clientUser/EN/Tech_05.png",
	"./clientUser/EN/Tech_06.png": "./src/assets/img/clientUser/EN/Tech_06.png",
	"./clientUser/EN/banner01.png": "./src/assets/img/clientUser/EN/banner01.png",
	"./clientUser/EN/banner02.png": "./src/assets/img/clientUser/EN/banner02.png",
	"./clientUser/EN/banner03.png": "./src/assets/img/clientUser/EN/banner03.png",
	"./clientUser/EN/banner04.png": "./src/assets/img/clientUser/EN/banner04.png",
	"./clientUser/EN/banner05.png": "./src/assets/img/clientUser/EN/banner05.png",
	"./clientUser/EN/banner06.png": "./src/assets/img/clientUser/EN/banner06.png",
	"./clientUser/EN/banner07.png": "./src/assets/img/clientUser/EN/banner07.png",
	"./clientUser/EN/banner08.png": "./src/assets/img/clientUser/EN/banner08.png",
	"./clientUser/EN/banner09.png": "./src/assets/img/clientUser/EN/banner09.png",
	"./clientUser/EN/banner10.png": "./src/assets/img/clientUser/EN/banner10.png",
	"./client_new_cn.png": "./src/assets/img/client_new_cn.png",
	"./client_new_cn1.png": "./src/assets/img/client_new_cn1.png",
	"./client_new_en.png": "./src/assets/img/client_new_en.png",
	"./client_new_en1.png": "./src/assets/img/client_new_en1.png",
	"./client_upgraded_cn.png": "./src/assets/img/client_upgraded_cn.png",
	"./client_upgraded_cn1.png": "./src/assets/img/client_upgraded_cn1.png",
	"./client_upgraded_en.png": "./src/assets/img/client_upgraded_en.png",
	"./client_upgraded_en1.png": "./src/assets/img/client_upgraded_en1.png",
	"./code-overview-bg.png": "./src/assets/img/code-overview-bg.png",
	"./column-setting.png": "./src/assets/img/column-setting.png",
	"./completed.png": "./src/assets/img/completed.png",
	"./default-avatar.png": "./src/assets/img/default-avatar.png",
	"./emoji.png": "./src/assets/img/emoji.png",
	"./face-normal.png": "./src/assets/img/face-normal.png",
	"./headerUser.png": "./src/assets/img/headerUser.png",
	"./history.png": "./src/assets/img/history.png",
	"./icon-authorise.png": "./src/assets/img/icon-authorise.png",
	"./icon-avatar.png": "./src/assets/img/icon-avatar.png",
	"./icon-contact.png": "./src/assets/img/icon-contact.png",
	"./icon-info.png": "./src/assets/img/icon-info.png",
	"./icon-introduction.png": "./src/assets/img/icon-introduction.png",
	"./icon-new-left-cn.png": "./src/assets/img/icon-new-left-cn.png",
	"./icon-new-left-en.png": "./src/assets/img/icon-new-left-en.png",
	"./icon-new-zh.png": "./src/assets/img/icon-new-zh.png",
	"./icon-overview-phone.png": "./src/assets/img/icon-overview-phone.png",
	"./icon_01.png": "./src/assets/img/icon_01.png",
	"./icon_02.png": "./src/assets/img/icon_02.png",
	"./icon_first_cn.png": "./src/assets/img/icon_first_cn.png",
	"./icon_first_en.png": "./src/assets/img/icon_first_en.png",
	"./inProgress.png": "./src/assets/img/inProgress.png",
	"./introduction_video_bg.png": "./src/assets/img/introduction_video_bg.png",
	"./kcc-logo-encn.png": "./src/assets/img/kcc-logo-encn.png",
	"./kee/bg-not-open.png": "./src/assets/img/kee/bg-not-open.png",
	"./kee/bg-open.png": "./src/assets/img/kee/bg-open.png",
	"./kee/icon.png": "./src/assets/img/kee/icon.png",
	"./kee/qrcode.png": "./src/assets/img/kee/qrcode.png",
	"./kp-logo-kcc.png": "./src/assets/img/kp-logo-kcc.png",
	"./kp-logo.png": "./src/assets/img/kp-logo.png",
	"./kpicon-new-1.png": "./src/assets/img/kpicon-new-1.png",
	"./kpicon-new-2.png": "./src/assets/img/kpicon-new-2.png",
	"./kpicon-new-3.png": "./src/assets/img/kpicon-new-3.png",
	"./kpicon-new-5.png": "./src/assets/img/kpicon-new-5.png",
	"./kpicon-new-6.png": "./src/assets/img/kpicon-new-6.png",
	"./level1.png": "./src/assets/img/level1.png",
	"./level2.png": "./src/assets/img/level2.png",
	"./level3.png": "./src/assets/img/level3.png",
	"./loginbg-kcc.png": "./src/assets/img/loginbg-kcc.png",
	"./loginbg-old.png": "./src/assets/img/loginbg-old.png",
	"./loginbg.png": "./src/assets/img/loginbg.png",
	"./logo_kcc_news.png": "./src/assets/img/logo_kcc_news.png",
	"./maintenance.png": "./src/assets/img/maintenance.png",
	"./manager.png": "./src/assets/img/manager.png",
	"./messageboard1.png": "./src/assets/img/messageboard1.png",
	"./messageboard2.png": "./src/assets/img/messageboard2.png",
	"./notApplicable.png": "./src/assets/img/notApplicable.png",
	"./notStarted.png": "./src/assets/img/notStarted.png",
	"./partner.png": "./src/assets/img/partner.png",
	"./qrCodeCn-client.png": "./src/assets/img/qrCodeCn-client.png",
	"./qrCodeCn-clientBig.png": "./src/assets/img/qrCodeCn-clientBig.png",
	"./qrCodeCn.png": "./src/assets/img/qrCodeCn.png",
	"./qrCodeEn-client.png": "./src/assets/img/qrCodeEn-client.png",
	"./qrCodeEn-clientBig.png": "./src/assets/img/qrCodeEn-clientBig.png",
	"./qrCodeEn.png": "./src/assets/img/qrCodeEn.png",
	"./rsdashboard_icon.png": "./src/assets/img/rsdashboard_icon.png",
	"./sad.png": "./src/assets/img/sad.png",
	"./sas-new-icon-en.png": "./src/assets/img/sas-new-icon-en.png",
	"./sas-new-icon-zh.png": "./src/assets/img/sas-new-icon-zh.png",
	"./site_hover_bg.png": "./src/assets/img/site_hover_bg.png",
	"./skull.png": "./src/assets/img/skull.png",
	"./smell.png": "./src/assets/img/smell.png",
	"./unvisible.png": "./src/assets/img/unvisible.png",
	"./unvisiunedit.png": "./src/assets/img/unvisiunedit.png",
	"./user.png": "./src/assets/img/user.png",
	"./visible.png": "./src/assets/img/visible.png",
	"./white_KCC-05.png": "./src/assets/img/white_KCC-05.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.png$";